// extracted by mini-css-extract-plugin
export default {"skeleton":"CaseItemWrapper_skeleton__gCaye"};